import React, {useState, useEffect} from 'react';
import {onlineProcessesService} from "../../services";
import QuadralBigNumber from '@quadral/quadral-component-common/dist/components/bigNumber'
import QuadralContainer from '@quadral/quadral-component-common/dist/components/container'
import QuadralList from '@quadral/quadral-component-common/dist/components/list';

const IncomeAndExpenses = ({participationId, participation, ...props}) => {
    const [rowsRFR, setRowsRFR] = useState([])
    const [rowsCharges, setRowsCharges] = useState([])

    const columnsRFR = [
        {
            id: "person",
            label: "Personne",
            sortable: true,
            typography: "tableBodyWide"
        },
        {
            id: "type",
            label: "Type",
            sortable: true,
        },
        {
            id: "value",
            label: "Montant",
            sortable: true,
            typography: "tableBodyWide"
        },
        {
            id: "status",
            label: "Justificatif",
            sortable: true,
        },
        {
            id: "action",
            label: "Actions",
        },
    ];

    const columnsCharges = [
        {
            id: "person",
            label: "Personne",
            sortable: true,
            typography: "tableBodyWide"
        },
        {
            id: "type",
            label: "Type",
            sortable: true,
        },
        {
            id: "nature",
            label: "Nature",
            sortable: true,
        },
        {
            id: "value",
            label: "Montant",
            sortable: true,
            typography: "tableBodyWide"
        },
        {
            id: "status",
            label: "Justificatif",
            sortable: true,
        },
        {
            id: "action",
            label: "Actions",
        },
    ];

    function splitData(data){
        setRowsRFR(data.filter(item => item?.type === 'revenu' ||  item?.type === 'RFR'));
        setRowsCharges(data.filter(item => item?.type === 'prestations_sociales'));
    }

    useEffect(()=>{
        if(props.personIds && props.personIds.length > 0 && participation){
            const promises = props.personIds.map(personId => 
                onlineProcessesService.getIncomeAndCharges(participationId,personId)
            )
            Promise.all(promises)
            .then(dataReceived => {
                const mergedData = dataReceived.flat();
                splitData(mergedData)
            })
            .catch(err => {
                    console.error(err);
            });
        }
    }, [props.personIds, participation, participationId])

    return(<>
        <QuadralContainer sx={{gap: '20px'}}>
            <QuadralContainer orientation='row' sx={{gap: '32px', paddingBottom: '1rem'}}>
                <QuadralBigNumber
                    title='Total Revenu(s) Mensuel(s)'
                    value='ADD_VALUE_HERE'
                />
                <QuadralBigNumber
                    title='Total Prestations'
                    value='ADD_VALUE_HERE'
                />
                <QuadralBigNumber
                    title='Revenu Total Foyer'
                    value={
                        participation?.totalRevenue != null
                        ? `${participation.totalRevenue.toLocaleString('fr-FR')} €`
                        : ''
                    }
                    color='primary'
                />
                <QuadralBigNumber
                    title='RFR Total'
                    value={
                        participation?.totalRFR != null
                        ? `${participation.totalRFR.toLocaleString('fr-FR')} €`
                        : ''
                    }
                    color='primary'
                />
            </QuadralContainer>
            <QuadralList
                title='Revenu fiscal de référence'
                columns={columnsRFR}
                rows={rowsRFR}
                sortable
            />
            <QuadralList
                title='Revenus et prestations du foyer'
                columns={columnsCharges}
                rows={rowsCharges}
                sortable
            />
        </QuadralContainer>
    </>)
}

export default IncomeAndExpenses;